/* eslint react/prop-types: 0 */
import React from 'react'
import content from 'pp-react-l10n'
import { trackClickUnifiedSend } from 'transfer/utils/unified-send-analytics'

const i18nPaymentType = content('transfer/inc/paymentTypeChoices')

export default ({
  // the extra space here needs to be removed once we sure it's not needed
  text = ` ${i18nPaymentType('goods.purchaseProtection')}`,
  link = i18nPaymentType('goods.purchaseProtectionLink'),
}) => {
  const handlePurchaseProtectionClick = event => {
    event.stopPropagation()
    trackClickUnifiedSend('purchaseProtection')
  }

  return (
    <a
      onClick={handlePurchaseProtectionClick}
      style={{ fontWeight: '700' }}
      href={link}
      target="_blank"
    >
      {text}
    </a>
  )
}
